(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lb-retailer-login/assets/javascripts/login.js') >= 0) return;  svs.modules.push('/modules/lb-retailer-login/assets/javascripts/login.js'); 'use strict';

const {
  useState,
  useRef
} = React;
const {
  jupiter,
  session,
  deviceSession
} = svs.core;
const {
  Button
} = svs.ui;
const {
  Input
} = svs.ui.form;
const {
  source
} = svs.lb_retailer_login.data;
const {
  url
} = svs.lb_retailer_login.data.login;

const saveLastLoginTime = (lastLoginTime, cb) => {
  if (lastLoginTime) {
    deviceSession.set('lastLoginTime', null, lastLoginTime, cb);
  } else if (Object.prototype.hasOwnProperty.call(session.data.session, 'lastLoginTime')) {
    deviceSession.remove('lastLoginTime', null, cb);
  } else {
    cb();
  }
};


const saveUserNotifications = (notif, cb) => {
  if (notif && notif.REDIRECT) {
    deviceSession.set('userNotifications', null, {
      redirect: true
    }, cb);
  } else if (Object.prototype.hasOwnProperty.call(session.data.session, 'userNotifications')) {
    deviceSession.remove('userNotifications', null, cb);
  } else {
    cb();
  }
};


const saveSequenceNumber = (sequenceNum, cb) => {
  if (sequenceNum) {
    deviceSession.set('sequencenumber', null, sequenceNum, cb);
  } else if (Object.prototype.hasOwnProperty.cakk(session.data.session, 'sequencenumber')) {
    deviceSession.remove('sequencenumber', null, cb);
  } else {
    cb();
  }
};

function Login({
  history
}) {
  const [retailerId, setRetailerId] = useState('');
  const [retailerUsername, setRetailerUsername] = useState('');
  const [retailerPassword, setRetailerPassword] = useState('');
  const retailerPasswordEl = useRef(null);
  const [errorMessage, setErrorMessage] = useState('');

  function handleSubmit(e) {
    e.preventDefault();

    function onLoginSuccess(result) {
      const {
        userNotifications: {
          REDIRECT: mustChangePwd
        } = {}
      } = result;

      if (mustChangePwd) {
        history.replace("/byt-losenord?returnUrl=".concat(url));
        return;
      }

      saveLastLoginTime(result.lastLoginTime, () => {
        saveUserNotifications(result.userNotifications, () => {
          saveSequenceNumber(result.sequenceNum, () => {
            location.href = url;
          });
        });
      });
    }

    function onLoginError(response) {
      let errorCode = -1;
      const messageBoxOptions = {
        title: 'Tekniskt fel',
        message: 'Var vänlig försök igen senare.',
        type: svs.components.MessageBox.Type.ERROR,
        buttons: [{
          type: svs.components.MessageBox.ButtonType.OK,
          text: 'Stäng'
        }],
        className: 'retailer-login-msg',
        show: true
      };

      if (response.responseText) {
        errorCode = JSON.parse(response.responseText).error.code;
      }

      switch (errorCode) {
        case 2: 

        case 13:
          messageBoxOptions.show = false;
          setErrorMessage('Fel lösenord eller användarnamn');
          retailerPasswordEl.current.focus();
          retailerPasswordEl.current.select();
          break;

        case 5:
          messageBoxOptions.type = svs.components.MessageBox.Type.DEFAULT;
          messageBoxOptions.title = 'Kontot är låst';
          messageBoxOptions.message = 'Ditt lösenord är nu ogiltigt p.g.a. många felaktiga inloggningsförsök.<br/>Kontakta ombudssupport 020-78 83 55';
          break;

        case 6:
          setErrorMessage('Spärrat konto');
          messageBoxOptions.type = svs.components.MessageBox.Type.DEFAULT;
          messageBoxOptions.title = 'Inloggning misslyckades';
          messageBoxOptions.message = 'Ditt konto är spärrat.<br/>Vid frågor, kontakta ombudssupport 020-78 83 55';
          break;

        default:
          messageBoxOptions.type = svs.components.MessageBox.Type.DEFAULT;
          messageBoxOptions.title = 'Något gick fel';
          messageBoxOptions.message = 'Ett oväntat fel inträffade.<br/>Vid frågor, kontakta ombudssupport 020-78 83 55';
      }

      if (messageBoxOptions.show) {
        svs.components.MessageBox.show(messageBoxOptions);
      }
    }

    let fixedId = retailerId;

    if (retailerId[0] === '0') {
      fixedId = retailerId.slice(1);
    }

    const options = {
      path: '/retailer/1/sessions/webterminal',
      data: {
        userName: fixedId + retailerUsername,
        password: retailerPassword,
        source
      },
      useExtErrFunc: false
    };
    jupiter.post(options, onLoginSuccess, onLoginError);
  }

  return React.createElement("div", {
    className: "bg-white border-grey-300 padding-3 margin-bottom-2",
    style: {
      width: 465,
      borderWidth: 1,
      borderStyle: 'solid',
      marginLeft: 'auto',
      marginRight: 'auto',
      borderRadius: 4
    }
  }, React.createElement("form", {
    className: "control-group".concat(errorMessage ? ' error' : '', " margin-bottom-0"),
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-800 margin-bottom-1",
    style: {
      fontSize: 22
    }
  }, "Ombud - Logga in"), React.createElement("div", {
    className: "control-group"
  }, React.createElement("label", {
    htmlFor: "retailer_id"
  }, "OMBUDSNUMMER (ENDAST SIFFROR)"), React.createElement(Input, {
    className: "qa-retailer-id",
    id: "retailer_id",
    onChange: e => setRetailerId(e.target.value.replace(/\D/g, '').trim()),
    pattern: "[0-9]+",
    placeholder: "ex. 1234567",
    required: true,
    type: "text",
    value: retailerId
  })), React.createElement("div", {
    className: "control-group"
  }, React.createElement("label", {
    htmlFor: "retailer_username"
  }, "ANV\xC4NDARNAMN (SAMMA SOM I TERMINALEN)"), React.createElement(Input, {
    className: "qa-retailer-username",
    id: "retailer_username",
    minLength: 2,
    onChange: e => setRetailerUsername(e.target.value.trim()),
    placeholder: "ex. Emma Eriksson",
    required: true,
    type: "text",
    value: retailerUsername
  })), React.createElement("div", {
    className: "control-group margin-bottom-2"
  }, React.createElement("div", {
    className: "has-input-action input-action-has-label js-input-action-show-password"
  }, React.createElement("label", {
    htmlFor: "retailer_password"
  }, "L\xD6SENORD (SAMMA SOM I TERMINALEN)"), React.createElement("i", {
    className: "js-input-action input-action"
  }), React.createElement("input", {
    className: "js-input std-input qa-retailer-password",
    id: "retailer_password",
    onChange: e => setRetailerPassword(e.target.value),
    ref: retailerPasswordEl,
    required: true,
    type: "password",
    value: retailerPassword
  })), React.createElement("div", {
    className: "error-message"
  }, errorMessage)), React.createElement(Button, {
    block: true,
    className: "qa-login",
    focus: true,
    type: "submit"
  }, "LOGGA IN")));
}

setGlobal('svs.lb_retailer_login.Login', Login);
 })(window);